module.exports = __webpack_public_path__ + "static/chandana-742ac73fe5088156f3d794e0bd3189c6.jpg";